export type Portrait = { src: string; alt: string };

export const portraits: Portrait[] = [
  {
    "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/2eff09cc-f721-4e4f-9c8e-88096b4eef36/luiza-prado-maurizio-mancioli.png",
    "alt": "by Maurizio Mancioli"
  },
  {
    "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/022b8bb3-a242-4976-baf0-f6b5ff45828b/luiza_prado_portrait_hifa_cybe.jpg",
    "alt": "by Xikaria"
  },
  {
    "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b89441a3-a076-4182-8842-1a2b2e58df99/luiza_prado_portrait_hifa_cybe.jpeg",
    "alt": "Self Portrait"
  },
  {
    "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/f3942ce9-8d18-4033-ab3f-6c7448bf6f4d/luiza_prado_shibari_portrait_ana_vohs.jpg",
    "alt": "by Ana Vohs"
  },
  {
    "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/5d13a49a-7a6a-4dbc-864f-5ada7b361208/DSC01531.png",
    "alt": "by Maurizio Mancioli"
  },
  {
    "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/ace0ecb0-c310-4e2e-bb8e-070f3bc3a81f/portrait_luiza_prado.jpg",
    "alt": "Black and white photo of a woman with tattoos, wearing a sleeveless black dress, posing with her hands on her head against a dark background."
  },
  {
    "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/d1d96f3c-d062-423f-a564-33f48d48dfc9/luiza_prado_portrait_hifa_cybe.jpeg",
    "alt": "A woman with long dark hair and tattoos on her arm, sitting with a cello in front of her, holding the scroll of the cello near her face while gazing at the camera in a room."
  },
  {
    "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/2c0dcc53-034e-4ad7-b842-f6fa560a0c50/luiza_prado_portrait_hifa_cybe.jpeg",
    "alt": "Self Portrait"
  },
  {
    "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/aa6bfbdd-ba53-4e0e-86a9-dbb6180ceb6b/luiza_prado_portrait_hifa_cybe.jpg",
    "alt": "by Juan Ribeiro"
  },
  {
    "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/91d65efe-e952-457b-8cab-2786f7d7577b/luiza_prado_portrait_hifa_cybe.png",
    "alt": "by Juan Ribeiro"
  },
  {
    "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/c721c590-9afc-4083-8fa9-99665f18fb8d/DSC01530.png",
    "alt": "A woman with black tattoos on her arms and chest, dressed in a black lace gown, walks down a small staircase through a yellow metallic curtain with her eyes closed."
  },
  {
    "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/b314cbe0-7bea-45f6-8263-9e0897ed298f/luiza_prado_portrait_hifa_cybe.jpg",
    "alt": "A woman with long, messy hair covering part of her face, wearing a dark shirt, looking at the camera with a serious expression in a black and white photo."
  },
  {
    "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/be9fa73e-671e-4c00-8798-45917896f4cb/luiza_prado_portrait_hifa_cybe.jpg",
    "alt": "A woman taking a photo of herself with a camera in a mirror, in a setting with plants and decorative wall art."
  },
  {
    "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/391ce8d9-1f17-4eef-90d0-d06f3d845306/luiza_prado_portrait_hifa_cybe.png",
    "alt": "by Juan Ribeiro"
  },
  {
    "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/332c50c3-d72b-4f45-9537-393e97346ecb/luiza_prado_portrait_hifa_cybe.png",
    "alt": "Self Portrait"
  },
  {
    "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/53dd5cfa-8ee4-49f0-8dee-d1e262845e64/luiza_prado_portrait_hifa_cybe.jpeg",
    "alt": "Self Portrait"
  },
  {
    "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/11532a05-ed01-49db-9b6b-394f6235536b/luiza_prado_portrait_hifa_cybe.jpeg",
    "alt": "Black and white photo of a woman with dark hair, wearing necklaces, with a serious expression."
  },
  {
    "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/9fb190a0-d9f6-409b-aca2-ae62b4da4ae3/luiza_prado_portrait_hifa_cybe.jpeg",
    "alt": "by Lucas Souza"
  },
  {
    "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/82093b2c-8032-4011-9266-11de9c8e9413/luiza_prado_portrait_hifa_cybe.jpg",
    "alt": "Close-up portrait of a woman with dark brown hair, blue eyes, and freckles, looking directly at the camera."
  },
  {
    "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/cefa06c8-6cae-48fd-8f79-94c82291e087/DSC01418.png",
    "alt": "by Maurizio Mancioli"
  },
  {
    "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/3c37443c-fa5e-499d-9a18-a41be458b6b4/luiza_prado_portrait.jpg",
    "alt": "Self Portrait"
  },
  {
    "src": "https://images.squarespace-cdn.com/content/v1/6842089013f5565b7d1e650d/0acfdfef-57db-47c8-b95c-26d94e2a8d4d/DSC01464.png",
    "alt": "A woman in a long black dress with tattoos on her arms and chest, standing on a white balcony inside a building, looking down with her hands on the railing. There is a framed pictu"
  }
];
